import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Lock } from 'lucide-react';

const HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_a3709e67-7648-4bcb-a123-219697b944ef/artifacts/aqwsfdgh_Martin_Aagaard_-_Kystlandskap_-_IMG_9313.jpg';

function GoogleIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09Z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.98.66-2.23 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z" />
      <path fill="#FBBC05" d="M5.84 14.11a6.6 6.6 0 0 1 0-4.22V7.05H2.18a11 11 0 0 0 0 9.9l3.66-2.84Z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.05l3.66 2.84C6.71 7.29 9.14 5.38 12 5.38Z" />
    </svg>
  );
}

export default function AdminLogin() {
  const { user, loginWithGoogleDirect } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      if (user.role === 'admin') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/portal', { replace: true });
      }
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen relative" data-testid="admin-login-page">
      {/* Background */}
      <div
        className="absolute inset-0 bg-center bg-cover opacity-25"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      />
      <div className="absolute inset-0 bg-[var(--cream)]/85" />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header */}
        <header className="p-6">
          <Link to="/" className="text-lg text-[var(--navy-800)] font-light tracking-widest">
            COASTWISE TRADE
          </Link>
        </header>

        <div className="flex-1 flex items-center justify-center px-6">
          <div className="w-full max-w-sm">
            <div className="flex flex-col items-center mb-8">
              <div className="h-12 w-12 border-[3px] border-[var(--navy-800)] flex items-center justify-center mb-5">
                <Lock className="h-6 w-6 text-[var(--navy-800)]" />
              </div>
              <h1 className="font-serif text-2xl text-[var(--navy-800)]">Administrator Access</h1>
              <p className="mt-2 text-sm text-[var(--muted-foreground)] text-center">
                Sign in with your Coastwise Workspace account.
              </p>
            </div>

            <button
              type="button"
              onClick={() => loginWithGoogleDirect()}
              className="btn-big w-full flex items-center justify-center gap-3"
              data-testid="admin-google-login-button"
            >
              <GoogleIcon />
              <span>Sign in with Google</span>
            </button>

            <p className="mt-8 text-center text-xs text-[var(--muted-foreground)]">
              Restricted to authorized Coastwise staff only.
            </p>
            <p className="mt-4 text-center text-sm">
              <Link to="/login" className="text-[var(--navy-800)] font-medium hover:underline">
                Client login
              </Link>
              <span className="mx-2 text-[var(--muted-foreground)]">·</span>
              <Link to="/" className="text-[var(--navy-800)] font-medium hover:underline">
                Home
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
